import { render } from "./PwdResetRequest.vue?vue&type=template&id=5a20e1bb&scoped=true&ts=true"
import script from "./PwdResetRequest.vue?vue&type=script&setup=true&lang=ts"
export * from "./PwdResetRequest.vue?vue&type=script&setup=true&lang=ts"

import "./PwdResetRequest.vue?vue&type=style&index=0&id=5a20e1bb&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a20e1bb"],['__file',"src/components/scan/admin/PwdResetRequest.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a20e1bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a20e1bb', __exports__)) {
    console.log('reload')
    api.reload('5a20e1bb', __exports__)
  }
  
  module.hot.accept("./PwdResetRequest.vue?vue&type=template&id=5a20e1bb&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('5a20e1bb', render)
  })

}


export default __exports__